import React from "react";
import { withTranslation } from 'react-i18next'

class ClassRoomItem extends React.Component {

    state = { showStudent: false, selectedStudent: [], showAssistantStudent: false, selectAll: false, selectAllAssistant: false, isFirst: true };

    static getDerivedStateFromProps(props, state) {
        if (props.selectedStudent && (state.isFirst || props.selectedStudent !== state.prevSelectedStudent)) {
            state.isFirst = false;
            state.prevSelectedStudent = props.selectedStudent;
            state.selectedStudent = props.selectedStudent;

            const classRoomStudents = (props.classRoom && props.classRoom.Students) ? props.classRoom.Students : [];
            if (classRoomStudents.length > 0 && props.selectedStudent.length > 0) {
                let selectAll = true;
                classRoomStudents.forEach(student => {
                    const sId = student.Id;
                    if (!props.selectedStudent.some(id => Number(id) === Number(sId))) {
                        selectAll = false;
                    }
                });
                state.selectAll = selectAll;

                let selectAllAssistant = true;
                const assistantStudents = classRoomStudents.filter(p => p.NeedAssistant === true);
                if (assistantStudents.length > 0) {
                    assistantStudents.forEach(student => {
                        const sId = student.Id;
                        if (!props.selectedStudent.some(id => Number(id) === Number(sId))) {
                            selectAllAssistant = false;
                        }
                    });
                    state.selectAllAssistant = selectAllAssistant;
                } else {
                    state.selectAllAssistant = false;
                }
            } else {
                state.selectAll = false;
                state.selectAllAssistant = false;
            }
        }
        return state;
    }

    showStudent = () => {
        this.setState({
            showStudent: !this.state.showStudent
        });
    }

    showAssistantStudent = () => {
        this.setState({
            showAssistantStudent: !this.state.showAssistantStudent
        });
    }

    SelectStudent = Id => {
        const { classRoom } = this.props;
        let selectedStudent = this.state.selectedStudent;
        selectedStudent.push(Id);
        let selectAll = false;
        if (selectedStudent.length === classRoom.Students.length) {
            selectAll = true;
        }

        var selectAllAssistant = true;
        classRoom.Students.filter(p => p.NeedAssistant === true).forEach(student => {
            if (!selectedStudent.includes(student.Id)) {
                selectAllAssistant = false;
            }
        });

        this.setState({
            selectedStudent,
            selectAll,
            selectAllAssistant
        });
        this.props.setSelect(selectedStudent);
    }
    DeselectStudent = Id => {
        const { classRoom } = this.props;

        let selectedStudent = this.state.selectedStudent;
        selectedStudent = selectedStudent.filter(function (ele) {
            return ele !== Id;
        });

        var selectAllAssistant = this.state.selectAllAssistant;
        if (selectAllAssistant) {
            selectAllAssistant = !(classRoom.Students && classRoom.Students.filter(p => p.NeedAssistant === true).some(p => p.Id === Id));
        }

        this.setState({
            selectedStudent,
            selectAll: false,
            selectAllAssistant
        });
        this.props.setDeselect([Id]);
    }

    selectAll = value => {
        if (value) {
            const { classRoom } = this.props;
            let selectedStudent = [];
            classRoom.Students && classRoom.Students.forEach(student => {
                selectedStudent.push(student.Id);
            });
            this.setState({
                selectedStudent
            });
            this.props.setSelect(selectedStudent);
            this.setState({
                selectAll: true,
                selectAllAssistant: true
            });
        } else {
            this.props.setDeselect(this.state.selectedStudent);
            this.setState({
                selectedStudent: []
            });
            this.setState({
                selectAll: false,
                selectAllAssistant: false
            });
        }

    }

    selectAllAssistant = value => {

        const { classRoom } = this.props;
        let selectedStudent = [];
        classRoom.Students && classRoom.Students.filter(p => p.NeedAssistant === true).forEach(student => {
            selectedStudent.push(student.Id);
        });

        if (value) {
            this.props.setSelect(selectedStudent);
            selectedStudent = [...selectedStudent, ...this.state.selectedStudent];
            this.setState({
                selectedStudent
            });
            this.setState({
                selectAll: selectedStudent.length === classRoom.Students.length,
                selectAllAssistant: value
            });
        } else {
            this.props.setDeselect(selectedStudent);
            this.setState({
                selectedStudent: this.state.selectedStudent.filter((e) => !selectedStudent.includes(e))
            });

            this.setState({
                selectAll: false,
                selectAllAssistant: value
            });
        }

    }

    render() {
        const { t, classRoom } = this.props;
        const students = (classRoom && classRoom.Students) ? classRoom.Students : [];
        const selectedCount = students.filter(s => this.state.selectedStudent.some(id => Number(id) === Number(s.Id))).length;
        const totalCount = students.length;
        const isAllSelected = totalCount > 0 && selectedCount === totalCount;
        const isPartiallySelected = selectedCount > 0 && selectedCount < totalCount;

        const assistantStudents = students.filter(p => p.NeedAssistant === true);
        const hasNeedAssistant = assistantStudents.length > 0;
        const assistantSelectedCount = assistantStudents.filter(s => this.state.selectedStudent.some(id => Number(id) === Number(s.Id))).length;
        const isAllAssistant = assistantStudents.length > 0 && assistantSelectedCount === assistantStudents.length;
        const isPartialAssistant = assistantSelectedCount > 0 && assistantSelectedCount < assistantStudents.length;

        return (
            <li className="py-1" style={{ listStyle: 'none' }}>
                <div className="d-flex align-items-center justify-content-between py-2 px-2 rounded bg-light border mb-1" style={{ transition: 'all 0.15s ease' }}>
                    <div className="d-inline-flex align-items-center">
                        <span className="cursor-pointer ml-2">
                            {isAllSelected ? (
                                <i className="icon fas fa-check-square text-success" style={{ cursor: 'pointer', fontSize: '1.1rem' }} title={t('Pages.Missions.deselect')} onClick={() => this.selectAll(false)}></i>
                            ) : isPartiallySelected ? (
                                <i className="icon fas fa-minus-square text-warning" style={{ cursor: 'pointer', fontSize: '1.1rem' }} title={`${t('Pages.Missions.PartiallySelected') || 'مختار جزئياً'} (${selectedCount}/${totalCount})`} onClick={() => this.selectAll(true)}></i>
                            ) : (
                                <i className="icon far fa-square text-muted" style={{ cursor: 'pointer', fontSize: '1.1rem' }} title={t('Pages.Missions.select')} onClick={() => this.selectAll(true)}></i>
                            )}
                        </span>
                        <span className="cursor-pointer font-weight-bold text-dark d-inline-flex align-items-center flex-wrap" style={{ cursor: 'pointer', fontSize: '0.92rem', gap: '6px' }} onClick={this.showStudent}>
                            <i className="icon fal fa-users-class text-primary ml-1"></i>
                            <span>{classRoom.Name}</span>
                            {(classRoom.Teacher?.Name || classRoom.TeacherName || classRoom.User?.Name) && (
                                <span className="badge badge-light border text-secondary font-weight-normal px-2 py-0" style={{ fontSize: '0.75rem', borderRadius: '8px' }}>
                                    <i className="fas fa-chalkboard-teacher ml-1 text-info"></i>
                                    {classRoom.Teacher?.Name || classRoom.TeacherName || classRoom.User?.Name}
                                </span>
                            )}
                            <i className={`fas fa-chevron-${this.state.showStudent ? 'up' : 'down'} text-muted mr-1`} style={{ fontSize: '0.72rem' }}></i>
                        </span>
                    </div>

                    {/* Badge Indicator for Selected Students Count / Partial Selection */}
                    <div>
                        {isPartiallySelected ? (
                            <span className="badge badge-warning text-dark px-2 py-1 font-weight-bold" style={{ fontSize: '0.75rem', borderRadius: '10px' }}>
                                <i className="fas fa-adjust ml-1" style={{ fontSize: '0.70rem' }}></i>
                                {t('Pages.Missions.PartiallySelected') || 'مختار جزئياً'}: {selectedCount} / {totalCount}
                            </span>
                        ) : isAllSelected ? (
                            <span className="badge badge-success px-2 py-1 font-weight-bold" style={{ fontSize: '0.75rem', borderRadius: '10px' }}>
                                <i className="fas fa-check-double ml-1"></i>
                                {totalCount} / {totalCount} ({t('Pages.Missions.All') || t('All') || 'الكل'})
                            </span>
                        ) : (
                            <span className="badge badge-light border text-muted px-2 py-1 font-weight-bold" style={{ fontSize: '0.75rem', borderRadius: '10px' }}>
                                {totalCount} {t('Student') || 'طالب'}
                            </span>
                        )}
                    </div>
                </div>

                {/* Subtree of Students when Expanded */}
                {this.state.showStudent && (
                    <div className="widget-body pr-3 pl-0 pb-0 pt-1" style={{ borderRight: '2px dashed #cbd5e1', marginRight: '10px' }}>
                        <ul className="pr-2 pl-0 mb-0" style={{ listStyle: 'none' }}>
                            {hasNeedAssistant && (
                                <li className="py-1 mb-1">
                                    <div className="d-flex align-items-center justify-content-between py-1 px-2 rounded" style={{ backgroundColor: '#fff7ed', border: '1px solid #ffedd5' }}>
                                        <div className="d-inline-flex align-items-center">
                                            <span className="cursor-pointer ml-2">
                                                {isAllAssistant ? (
                                                    <i className="icon fas fa-check-square text-success" style={{ cursor: 'pointer', fontSize: '1rem' }} title={t('Pages.Missions.deselect')} onClick={() => this.selectAllAssistant(false)}></i>
                                                ) : isPartialAssistant ? (
                                                    <i className="icon fas fa-minus-square text-warning" style={{ cursor: 'pointer', fontSize: '1rem' }} title={`${t('Pages.Missions.PartiallySelected') || 'مختار جزئياً'} (${assistantSelectedCount}/${assistantStudents.length})`} onClick={() => this.selectAllAssistant(true)}></i>
                                                ) : (
                                                    <i className="icon far fa-square text-muted" style={{ cursor: 'pointer', fontSize: '1rem' }} title={t('Pages.Missions.select')} onClick={() => this.selectAllAssistant(true)}></i>
                                                )}
                                            </span>
                                            <span className="cursor-pointer font-weight-bold d-inline-flex align-items-center flex-wrap" style={{ cursor: 'pointer', color: '#c2410c', fontSize: '0.85rem', gap: '6px' }} onClick={this.showAssistantStudent}>
                                                <i className="icon fal fa-chalkboard-teacher ml-1"></i>
                                                <span>{t("Pages.StudentInClassRoomsControl.NeedAssistant") || "الطلاب المحتاجين للمساعدة"}</span>
                                                {(classRoom.AssistantTeacher?.Name || classRoom.AssistantTeacherName) && (
                                                    <span className="badge badge-light border text-secondary font-weight-normal px-2 py-0" style={{ fontSize: '0.74rem', borderRadius: '8px', backgroundColor: '#fff' }}>
                                                        <i className="fas fa-user-friends ml-1 text-warning"></i>
                                                        {classRoom.AssistantTeacher?.Name || classRoom.AssistantTeacherName}
                                                    </span>
                                                )}
                                                <i className={`fas fa-chevron-${this.state.showAssistantStudent ? 'up' : 'down'} text-muted mr-1`} style={{ fontSize: '0.68rem' }}></i>
                                            </span>
                                        </div>
                                        {isPartialAssistant ? (
                                            <span className="badge badge-warning text-dark px-2 py-0 font-weight-bold" style={{ fontSize: '0.70rem' }}>
                                                {assistantSelectedCount} / {assistantStudents.length}
                                            </span>
                                        ) : isAllAssistant ? (
                                            <span className="badge badge-success px-2 py-0 font-weight-bold" style={{ fontSize: '0.70rem' }}>
                                                {assistantStudents.length} / {assistantStudents.length}
                                            </span>
                                        ) : null}
                                    </div>

                                    {this.state.showAssistantStudent && (
                                        <div className="pr-3 pl-0 pb-0 pt-1" style={{ borderRight: '2px dotted #fdba74', marginRight: '8px' }}>
                                            <ul className="pr-2 pl-0 mb-0" style={{ listStyle: 'none' }}>
                                                {assistantStudents.map(student => {
                                                    const isSelected = this.state.selectedStudent.some(id => Number(id) === Number(student.Id));
                                                    return (
                                                        <li key={`student-assistant-${student.Id}`} className="py-1">
                                                            <div
                                                                className="d-inline-flex align-items-center cursor-pointer px-2 py-1 rounded"
                                                                style={{ cursor: 'pointer', backgroundColor: isSelected ? '#eff6ff' : 'transparent', transition: 'background-color 0.15s' }}
                                                                onClick={() => isSelected ? this.DeselectStudent(student.Id) : this.SelectStudent(student.Id)}
                                                            >
                                                                <span className="ml-2">
                                                                    {isSelected ? (
                                                                        <i className="icon fas fa-check-square text-primary" title={t('Pages.Missions.deselect')}></i>
                                                                    ) : (
                                                                        <i className="icon far fa-square text-muted" title={t('Pages.Missions.select')}></i>
                                                                    )}
                                                                </span>
                                                                <i className="icon fal fa-user-graduate text-secondary ml-1" style={{ fontSize: '0.85rem' }}></i>
                                                                <span className="text-dark font-weight-bold" style={{ fontSize: '0.86rem' }}>
                                                                    {student.Name}
                                                                    {(student.User?.UserName || student.UserName) && (
                                                                        <span className="text-muted mr-2 font-weight-normal" style={{ fontSize: '0.78rem' }}>
                                                                            (@{student.User?.UserName || student.UserName})
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    )}
                                </li>
                            )}

                            {/* Regular Students */}
                            {students.filter(p => p.NeedAssistant === false).map(student => {
                                const isSelected = this.state.selectedStudent.some(id => Number(id) === Number(student.Id));
                                return (
                                    <li key={`student-${student.Id}`} className="py-1">
                                        <div
                                            className="d-inline-flex align-items-center cursor-pointer px-2 py-1 rounded"
                                            style={{ cursor: 'pointer', backgroundColor: isSelected ? '#eff6ff' : 'transparent', transition: 'background-color 0.15s' }}
                                            onClick={() => isSelected ? this.DeselectStudent(student.Id) : this.SelectStudent(student.Id)}
                                        >
                                            <span className="ml-2">
                                                {isSelected ? (
                                                    <i className="icon fas fa-check-square text-primary" title={t('Pages.Missions.deselect')}></i>
                                                ) : (
                                                    <i className="icon far fa-square text-muted" title={t('Pages.Missions.select')}></i>
                                                )}
                                            </span>
                                            <i className="icon fal fa-user-graduate text-secondary ml-1" style={{ fontSize: '0.85rem' }}></i>
                                            <span className="text-dark font-weight-bold" style={{ fontSize: '0.86rem' }}>
                                                {student.Name}
                                                {(student.User?.UserName || student.UserName) && (
                                                    <span className="text-muted mr-2 font-weight-normal" style={{ fontSize: '0.78rem' }}>
                                                        (@{student.User?.UserName || student.UserName})
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </li>
        );
    }

}
export default withTranslation('common')(ClassRoomItem);